export default "__VITE_ASSET__DdRxUAPy__"